import { render, staticRenderFns } from "./ModalErrorNotif.vue?vue&type=template&id=65cc9fa4&lang=pug&"
import script from "./ModalErrorNotif.vue?vue&type=script&lang=js&"
export * from "./ModalErrorNotif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports